import { NextRouter } from 'next/router'
import qs from 'query-string'

const redirectOnCtaUrl = (ctaLink: string, router: NextRouter) => {
  if (!ctaLink) return

  const isRelative = ctaLink.startsWith('/')

  if (isRelative) {
    router.push({
      pathname: '/',
      query: {
        ...qs.parseUrl(ctaLink).query
      }
    }, ctaLink)
    return
  }

  window.open(ctaLink, '_blank', 'noopener,noreferrer')
}

export default redirectOnCtaUrl
